import { COLORS } from '@btime/constants'
import { concatIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import {
  useOpenAvailabilityStatusSourceConfigModal,
  useOpenTriggersModal
} from '../../../utils/routes/modals/modalsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation('availability')

  const canListTriggers = useSessionPermission('listTrigger')
  const canEditStatusSource = useSessionPermission('editPlaceAvailabilityStatus')

  const openTriggersModal = useOpenTriggersModal()
  const openStatusSourceConfigModal = useOpenAvailabilityStatusSourceConfigModal()

  const options = [
    ...concatIf(canListTriggers, [
      {
        value: t('automations'),
        iconLeft: 'RiRobotLine',
        onClick: () => openTriggersModal({ entities: ['non_compliance', 'non_compliance_event'] })
      },

      { line: true }
    ]),

    ...concatIf(canEditStatusSource, [
      {
        value: t('statusSourceConfig.buttonLabel'),
        iconLeft: 'RiSettings3Line',
        onClick: () => openStatusSourceConfigModal()
      }
    ])
  ]

  return (
    <>
      <Separator weight={10} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('title')}
          </Title>
        </FlexCol>

        <FlexCol flex={1} />

        {!!options.length && (
          <FlexCol>
            <DropdownLink
              fromRight
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </FlexCol>
        )}
      </FlexGrid>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
